var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkmark Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10.5 0.511719C16.0228 0.511719 20.5 4.98887 20.5 10.5117C20.5 16.0346 16.0228 20.5117 10.5 20.5117C4.97715 20.5117 0.5 16.0346 0.5 10.5117C0.5 4.98887 4.97715 0.511719 10.5 0.511719ZM13.7197 7.48139L9.25 11.9511L7.28033 9.98139C6.98744 9.6885 6.51256 9.6885 6.21967 9.98139C5.92678 10.2743 5.92678 10.7492 6.21967 11.042L8.71967 13.542C9.01256 13.8349 9.48744 13.8349 9.78033 13.542L14.7803 8.54205C15.0732 8.24916 15.0732 7.77428 14.7803 7.48139C14.4874 7.1885 14.0126 7.1885 13.7197 7.48139Z",
    fill: "#009CDB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircle);
export default __webpack_public_path__ + "static/media/CheckmarkCircle.a4f7bc490d9b94e0f3a8f22cda5b3609.svg";
export { ForwardRef as ReactComponent };